import { CartItemKeys, CartKeys } from '@config/keys/cart.keys';
import { ShopKeys } from '@config/keys/shop.keys';
import { DoodCartModel } from '@core/models/cart.model';
import { DoodShopModel } from '@core/models/shop.model';
import { toShopRef } from '@core/services/link-navigation/link-navigation.service';

/** Shown only once the home shop lookup has already taken this long. */
export const KIOSK_HOME_LOADER_DELAY_MS = 300;

/**
 * After a payment reload the shop is no longer the active one.
 * The cart still keeps its id, and the product lines do too.
 */
export function kioskCartShopId(cart: DoodCartModel | null | undefined): string | null {
  const fromCart = cart?.[CartKeys.Shop];
  if (fromCart) {
    return fromCart;
  }

  return (
    cart?.[CartKeys.Products]?.find(product => product[CartItemKeys.ShopId])?.[
      CartItemKeys.ShopId
    ] ?? null
  );
}

/**
 * Payment and cart URLs have no shop segments. Home must use the loaded shop.
 * The active record can be an id-only stub; the full shop lives in the list.
 */
export function resolveKioskHomeShop(
  active: DoodShopModel | null | undefined,
  shops: DoodShopModel[],
  activeId: string | null | undefined,
): DoodShopModel | null {
  if (toShopRef(active ?? null)) {
    return active ?? null;
  }

  const id = active?.[ShopKeys.Id] ?? activeId;
  if (!id) {
    return active ?? null;
  }

  return shops.find(shop => shop[ShopKeys.Id] === id) ?? active ?? null;
}

export function kioskShopHomePath(shop: DoodShopModel | null | undefined): string | null {
  const ref = toShopRef(shop ?? null);
  if (!ref) {
    return null;
  }

  return `/${ref.shopCity}/${ref.shopType}/${ref.shopSlug}`;
}
